var _defs, _title, _circle, _path, _line;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgBoxingBoxer = function SvgBoxingBoxer(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Regular",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}"))), _title || (_title = /*#__PURE__*/React.createElement("title", null, "boxing-boxer")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 11.5,
    cy: 3.375,
    r: 2.625
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M18.25,7.5h-9a1.5,1.5,0,0,0-1.415,1l-4.5,12.75a1.5,1.5,0,0,0,.915,1.915,1.536,1.536,0,0,0,.5.085,1.5,1.5,0,0,0,1.415-1l1.811-5.133,2.138,1.106.489,3.722a1.5,1.5,0,0,0,1.486,1.3,1.455,1.455,0,0,0,.2-.013,1.5,1.5,0,0,0,1.292-1.682l-.488-3.719a3,3,0,0,0-1.6-2.279l-2.507-1.3,1.326-3.76h5.827a2.246,2.246,0,1,0,2.112-3Z"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 15.25,
    y1: 7.5,
    x2: 15.25,
    y2: 10.5
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBoxingBoxer, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/boxing-boxer.5b88eba6.svg";
export { ForwardRef as ReactComponent };